export enum ConfigurationElementTypeDto {
    ENUM = 'enum',
    BOOLEAN = 'bool',
    COLOR = 'color',
    NUMBER = 'num',
    STRING = 'str',
    TEXT = 'text',
    TEXTAREA = 'textarea',
    LIST = 'list',
    DATALIST = 'dataList',
    OBJECTLIST = 'objectList',
}
